import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private isStaticAssetRequest(url: string): boolean {
    const lower = url.toLowerCase();
    return lower.includes('/assets/') || lower.startsWith('assets/')
        || lower.includes('/import-maps/') || lower.startsWith('import-maps/');
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    console.log('[AuthInterceptor]', req.url, '| isStaticAsset:', this.isStaticAssetRequest(req.url));
    if (this.isStaticAssetRequest(req.url)) {
      return next.handle(req);
    }
    const authToken = sessionStorage.getItem('token');
    const authorizationToken = sessionStorage.getItem('authToken');
      const authReq = req.clone({
        headers: req.headers
        .set('Authorization', 'Bearer ' + authToken)
        .set('x-auth', 'Bearer ' + authorizationToken)
      });
      return next.handle(authReq);
    }    
}